import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateCartPurchase } from "../../../services/purchaseApi";

// only exist in pbf purchase
export const useUpdateCartPbf = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: updateCartPurchase,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["purchase-cart-pbf"] }); // invalidates cart
        }
    });
};
